import { getUrlParam, getVtxToken } from '@vtx/utils';
import { GeoJsonDataSource } from 'cesium';
import http from './http';
import encryptParams from './encryptParams';
import { getResource } from './getToken';

const handleResult = (features, field, key) => {
    return features.map(v => {
        let properties = v._properties?.getValue(v._id) || {};
        properties = properties?.properties || properties;
        properties.label = properties?.[field];
        properties.value = properties?.key || properties?.id || properties?.facilityId || properties?.[field];
        properties.feature = v;
        if (key) {
            v.key = key;
        }

        return properties;
    });
};

// 根据关键字获取图形信息
export const getVectorFeatureInfoByText = (layer, field, searchText) => {
    let features = layer.entities?.values || [];
    if (features?.length) {
        let _features = features.filter(v => {
            if (v.ignoreSearch) {
                return false;
            }
            let properties = v._properties?.getValue(v._id) || {};
            properties = properties?.properties || properties;
            return ((v.show && properties?.[field]) || '').indexOf(searchText) !== -1;
        });

        if (_features?.length) {
            return handleResult(_features, field);
        }
    }
};

export const getWFSFeatureInfoByLayer = (layer, _cql_filter) => {
    let imageryProvider = layer?._imageryProvider || {};
    let tenantId =
        getUrlParam('tenantId') || localStorage.getItem('tenantId') || getVtxToken('tenantId');
    let params = {
        maxFeatures: 50,
        service: 'WFS',
        request: 'GetFeature',
        version: '1.1.0',
        outputFormat: 'application/json',
        geoserverUrl: imageryProvider._pickFeaturesResource._url || imageryProvider?._getFeatureInfoUrl,
        typeName: imageryProvider?._layers,
        cql_filter: layer?.params?.cql_filter || imageryProvider._pickFeaturesResource.queryParameters.cql_filter || '',
        viewparams: `tenantId:${tenantId}`,
    };

    if (params.cql_filter || _cql_filter) {
        params.cql_filter = params.cql_filter ? `${_cql_filter} and (${params.cql_filter})` : _cql_filter;

        if (layer.encrypt) {
            params = encryptParams(params, layer.encrypt);
        } else {
            params.cql_filter = encodeURIComponent(params.cql_filter);
        }
    }

    if (!params.cql_filter) {
        delete params.cql_filter;
    }

    const url = getResource(`${imageryProvider?._getFeatureInfoUrl}`, {
        token: layer.token,
        params
    });
    let _layer = GeoJsonDataSource.load(url, {
        clampToGround: true,
        zIndex: 3,
    });

    return _layer.then(dataSource => {
        let features = [];
        if (dataSource?.entities?.values?.length) {
            features = handleResult(dataSource.entities.values, '', layer?.key);
        }
        return features;
    });
};

export const getFeaturesInfoByLayer = (layer, _params) => {
    const {cql_filter, ...otherVal} = _params;
    let imageryProvider = layer?._imageryProvider || {};
    let tenantId =
        getUrlParam('tenantId') || localStorage.getItem('tenantId') || getVtxToken('tenantId');
    let params = {
        maxFeatures: 9999,
        service: 'WFS',
        request: 'GetFeature',
        version: '1.1.0',
        outputFormat: 'application/json',
        geoserverUrl: imageryProvider?._getFeatureInfoUrl,
        typeName: imageryProvider?._layers,
        cql_filter: imageryProvider._pickFeaturesResource.queryParameters.cql_filter || '',
        viewparams: `tenantId:${tenantId}`,
        ...otherVal
    };

    if (params.cql_filter || cql_filter) {
        params.cql_filter = params.cql_filter ? `${cql_filter} and (${params.cql_filter})` : cql_filter;
        if (layer.encrypt) {
            params = encryptParams(params, layer.encrypt);
        } else {
            params.cql_filter = encodeURIComponent(params.cql_filter);
        }

    }

    if (!params.cql_filter) {
        delete params.cql_filter;
    }



    const queryString = Object.entries(params)
        .reduce((acc, [key, value]) => {
            return `${acc}${key}=${value}&`;
        }, '?')
        .slice(0, -1);


    return http.get(`${imageryProvider?._getFeatureInfoUrl}${queryString}`);
};

// 根据条件查询wms图层
export const getWmsFeatureInfoByText = (layer, field, searchText) => {
    let imageryProvider = layer?._imageryProvider || {};
    let tenantId =
        getUrlParam('tenantId') || localStorage.getItem('tenantId') || getVtxToken('tenantId');
    let params = {
        maxFeatures: 50,
        service: 'WFS',
        request: 'GetFeature',
        version: '1.1.0',
        outputFormat: 'application/json',
        geoserverUrl: imageryProvider?._getFeatureInfoUrl,
        typeName: imageryProvider?._layers,
        cql_filter: imageryProvider._pickFeaturesResource.queryParameters.cql_filter,
        viewparams: `tenantId:${tenantId}`,
    };

    let cql_filter = `${field} like '%${searchText}%'`;

    params.cql_filter = params.cql_filter ? `${cql_filter} and (${params.cql_filter})` : cql_filter;

    if (layer.encrypt) {
        params = encryptParams(params, layer.encrypt);
    } else {
        params.cql_filter = encodeURIComponent(params.cql_filter)
    }

    const queryString = Object.entries(params)
        .reduce((acc, [key, value]) => {
            return `${acc}${key}=${value}&`;
        }, '?')
        .slice(0, -1);

    const url = getResource(`${imageryProvider?._getFeatureInfoUrl}${queryString}`, {
        token: layer.token,
    });
    let _layer = GeoJsonDataSource.load(url, {
        clampToGround: true,
        zIndex: 3,
    });

    return _layer.then(dataSource => {
        let features = [];
        if (dataSource?.entities?.values?.length) {
            features = handleResult(dataSource.entities.values, field, layer?.key);
            if (features?.length) {
                features.map(v => {
                    if (v?.feature?._billboard?._image) {
                        v.feature._billboard._image = null;
                    }
                });
            }
        }
        return features;
    });
};

// 根据poi 兴趣点查询
export const poiSearch = async val => {
    const res = await http.get('/cloud/management/api/v101/user/config/component/page', {
        body: {
            componentCode: 'Bookmark',
        },
    });
    let list = [];
    if (res?.result === 0) {
        const configInfo = res.data?.rows?.[0]?.configInfo;
        if (configInfo) {
            let data = JSON.parse(configInfo);
            list = data
                .filter(item => item.name.includes(val.keywords))
                .map((item, index) => ({
                    ...item,
                    label: item.name,
                    value: item.id,
                    index,
                    lngLat: item.geometryInfo.lngLats.split(',').map(v => Number(v)),
                }));
        }
    }
    return list;
};
